var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"squ-view"},_vm._l((_vm.blockList),function(item){return _c('div',{key:item.val,staticClass:"squ-item"},[_c('div',{staticClass:"item-top"},[_vm._v(_vm._s(_vm.blockNums[item.val]))]),_c('div',{staticClass:"item-bott"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }